'use client';

import { McPlatinumIcon } from '@/components/icons/mc-platinum-icon';
import { RichTextRenderer } from '@/components/rich-text/rich-text-renderer';
import { Anchor } from '@/components/ui/anchor';
import { useDataAnalytics } from '@/hooks/analytics/analytics';
import { SubscriptionSection } from '@cinemark/content-api-client';

type PlatinumBodyProps = {
  dataLinkCategory: string;
  hideCTA?: boolean;
  subscriptionSection: SubscriptionSection;
};

export const PlatinumBody = ({ dataLinkCategory, hideCTA, subscriptionSection }: PlatinumBodyProps): React.JSX.Element => {
  const { trackClick } = useDataAnalytics();

  return (
    <div className="flex flex-col items-center gap-md">
      <McPlatinumIcon className="w-full h-14" />
      {!!subscriptionSection.header2 && <h2 data-test="mc-platinum-header">{subscriptionSection.header2}</h2>}
      {!!subscriptionSection.blurb1 &&
        <div className="w-full md:w-2/3 text-center">
          <RichTextRenderer content={subscriptionSection.blurb1} />
        </div>
      }
      {!!subscriptionSection.blurb2 &&
        <div className="w-full md:w-2/3 text-center">
          <RichTextRenderer content={subscriptionSection.blurb2} />
        </div>
      }
      {!hideCTA && !!subscriptionSection.buttonCta && !!subscriptionSection.buttonHref &&
        <Anchor data-test="mc-platinum-cta"
          href={subscriptionSection.buttonHref}
          size="lg"
          onClick={() => trackClick({
            linkCategory: dataLinkCategory,
            linkName: 'Movie Club Platinum CTA',
          })}
        >
          {subscriptionSection.buttonCta}
        </Anchor>
      }
    </div>
  );
};
